import { Component, DestroyRef, Input, inject } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { WebEngageRepository } from '@core/services/repositories/webEngage.repository';
import { HotelHeader } from '@core/models/domains/hotel';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-pdp-map',
 standalone: true,
 imports: [CommonModule, MatButtonModule, RouterLink, NgOptimizedImage],
 templateUrl: './map.component.html',
 styleUrls: ['./map.component.scss'],
})
export class PdpMapComponent {
 webEngageRepo = inject(WebEngageRepository);
 @Input() dataSource?: HotelHeader;
 destroyRef = inject(DestroyRef);



 runWebEngageApi() {
  // if (this.dataSource) {
  //  this.webEngageRepo
  //   .mapClick(this.dataSource.FullName)
  //   .pipe(takeUntilDestroyed(this.destroyRef))
  //   .subscribe(() => {});
  // }
 }
}
